import React, { Component } from 'react';
import styled, { css as StyledCSS } from 'styled-components';
import css from 'css';
import WP from 'WP';
import api from 'api';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Header from 'partials/Header';
import Footer from 'partials/Footer';
import AspectRatio from 'partials/AspectRatio';
import SearchIcon from 'images/SearchIcon';

class Blog extends Component {

    constructor()
    {
        super();
        this.state = {
            initialBlogPosts: [],
            blogs: [],
            blogCategories: [],
            blogTextSearch: "",
            blogLimit: 6,
        }
    }

    componentDidMount()
    {
        this._loadBlogPosts();
        this._loadBlogCategories();
    }

    _loadBlogPosts = () => {
        api.blogFetcher.getPosts().then(response => {
            this.setState({ initialBlogPosts : response.data, blogs: response.data });
        })
    }

    _loadBlogCategories = () => {
        api.categoryTermFetcher.getPosts().then(response => {
            this.setState({  blogCategories : response.data });
        });
    }

    _onSearchBlogByText = (event) => {
		const { initialBlogPosts } = this.state;
		var updatedList = initialBlogPosts;
        let searchString = event.target.value.toLowerCase();

		updatedList = updatedList.filter(blog => {
			this.setState({ textSearch : searchString });
			return blog.title.rendered.toLowerCase().search(searchString) !== -1;
		});
		this.setState({ blogs: updatedList });
    }

    _onSearchBlogByCategory = (event) => {
        var category = parseInt(event.target.value);
		const { initialBlogPosts } = this.state;
		var updatedList = initialBlogPosts;
		if(isNaN(category))
		{
			this.setState({ blogs :updatedList });
		} else {
			var updatedList = initialBlogPosts;
			updatedList = updatedList.filter(blog => blog.kategori.includes(category));
			this.setState({ blogs :updatedList });
		}
    }

    _onClickLoadMoreBlogs = () => {
        const { blogLimit } = this.state;
        this.setState({ blogLimit: blogLimit + blogLimit });
    }

    render()
    {
        const { blogs, blogCategories, blogLimit} = this.state;
        const { blog_archive_photo } = WP.options;
   

        return(
			<Wrapper>
				<HeaderWrapper backgroundPhoto={blog_archive_photo}>
					<div className="container">
						<StyledHeader color="white" />
						<div className="title">Blogg</div>
						<InputWrapper>
							<div className="row">
								<div className="search-bar">
									<input type="search" onChange={this._onSearchBlogByText} placeholder="Søk i blogg artikler" />
									<span className="search-button"><SearchIcon /></span>
								</div>
								<div className="dropdown-bar">
									<span className="filterText">Filtrer på kategori</span>
									<select onChange={this._onSearchBlogByCategory}>
										<option value="all">Alle</option>
										{blogCategories.map((category, index) => (
											<option value={category.id} key={index}>{category.name}</option>
										))}
									</select>
								</div>
							</div>
						</InputWrapper>
					</div>
				</HeaderWrapper>
                <BlogContainer>
                    { blogs.length > 0 && blogs.slice(0, blogLimit).map((blog, index) => {
                        return(
                            <BlogPost index={index}>
                                <StyledAspectRatio url={blog.acf.feature_photo.url} className="image" w="480" h="320" background ratio="1:1" />
                                <a className="title" href={blog.link} ><h3>{blog.post_title || blog.title.rendered}</h3></a>
                                <p>{blog.acf.ingress}</p>
                            </BlogPost> 
                        )
                    })}
                </BlogContainer>
                {blogs.length > 0 && <LoadMoreBlogsButton onClick={this._onClickLoadMoreBlogs}>Last inn flere</LoadMoreBlogsButton>}
				<Footer />
			</Wrapper>
        );
    }

}

const mapStateToProps = (state, props) => ({
	blog: state.blog
});

const actions = {
}

export default connect(mapStateToProps, actions)(withRouter(Blog));

const Wrapper = styled.div`
	position: relative;
	width: 100%;
`;

const HeaderWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 450px;
	padding-top: 30px;
	margin-bottom: 100px;

	${props => props.backgroundPhoto && StyledCSS`
		background-image: url(${props.backgroundPhoto.url});
	  	background-position: center;
	  	background-repeat: no-repeat;
	  	background-size: cover;
	`}

	.container {
		display: flex;
		flex-wrap: wrap;
		flex-direction: row;
		max-width: 1260px;
		margin: 0 auto;

	}

	.title {
		flex: 0 0 100%;
		${css.fonts.SpectralBold};
		font-size: 64px;
		color: #FFFFFF;
		line-height: 74px;
		padding-top: 120px;
	}

	 @media(max-width: 767px) {
	 	.title {
	 		padding-left: 30px;
	 	}
	 }

	 @media(max-width: 1024px) {
	 	.title {
	 		padding-left: 30px;
	 	}
	 }
`;

const StyledAspectRatio = styled(AspectRatio)`
	 padding-bottom: 320px;
`;

const StyledHeader = styled(Header) `
	header {
		position: relative;
	}
`;

const InputWrapper = styled.div`
	position: relative;
	flex: 0 0 100%;
	padding-top: 50px;

	.row {
		display: flex; 
		flex-wrap: wrap;
		flex-direction: row;
		justify-content: space-between;
	}

	.search-bar {
		position: relative;
		flex: 0 0 40%;
		padding-top: 30px;


	    input[type='search'] {
			position: relative;
			width: 100%;
			height: 56px;
			background: #EEEEEE;
			${css.fonts.SSProRegular};
			font-size: 24px;
			color: #002857;
			line-height: 34px;
			border: 2px solid #2472B9;
			transition: border .2s linear;
			padding: 10px;
	    }

	    ::placeholder {
	        color: #357c88;
	    }

	    input[type='search']:focus {
	        transition: border .2s linear;
			outline: none;
	    }

	    .search-button {
	        position: absolute;
	        font-size: 20px;
	        color: #66757f;
	        background-color: transparent;
	        border:none;
	        right: 3%;
	        top: 40px;
	        outline: none;
	    }

		 @media(max-width: 767px) {
		 	flex: 0 0 100%;
		 	padding: 0 30px;

		 	.search-button {
		 		top: 10px;
		 		right: 10%;
		 	}
		 }

		 @media(max-width: 1024px) {
			padding-left: 30px;
		 }

	}

	.dropdown-bar {
		position: relative;
		flex: 0 0 20%;

	    .filterText {
			font-size: 24px;
			color: #FFFFFF;
			line-height: 34px;
			${css.fonts.SSProRegular};
	    }

		select {
	        transition: border .2s linear;
	        font-size: 20px;
			${css.fonts.SSProRegular};
	        width: 100%;
	        background-color: #FFF;
	        color: #357c88;
	        padding: 8px 32px 8px 12px;
	        height: 56px;
	        border: 1px solid #e6ecf0;
	        outline: none;
	        text-align-last:center;
		}

		 @media(max-width: 1024px) {
		 	margin-right: 30px;
		 	flex: 0 0 30%;
		 }

		 @media(max-width: 767px) {
		 	flex: 0 0 100%;
		 	padding: 0 30px;
		 	padding-top: 10px;
		 }
	}
`;


const BlogContainer = styled.div`
	position: relative;
	width: 100%;
	max-width: 1260px;
	margin: 0 auto;
	
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	justify-content: center;

	@media(max-width: 1024px) {
		padding: 0 20px;
	}

	@media(max-width: 767px) {
		padding: 0;
	}
`;

const BlogPost = styled.div`
    flex: 0 0 50%;
	max-width: 480px;
	padding-bottom: 60px;

    .title {
        ${css.fonts.SSProSemiBold};
        font-size: 24px;
        color: #002857;
        line-height: 34px;
    }

    p {
        ${css.fonts.SSProRegular};
        font-size: 16px;
        color: #002857;
        line-height: 24px;
        padding-top: 25px;
    }

	&:nth-child(2n) {
		padding-left: 40px;
	}

	@media(max-width: 1024px) {
		padding-right: 30px;
	}

    @media(max-width: 767px) {
        flex: 0 0 100%;
		padding: 30px;

		&:nth-child(2n) {
			padding: 30px;
		}
    }
`;

const LoadMoreBlogsButton = styled.button`
    flex: 0 0 100%;
    max-width: 160px;
    padding: 10px 20px;
    border: 1px solid red;
    margin-top: 45px;
    margin-left: 45%;
    margin-bottom: 190px;
	${css.fonts.SSProRegular};

    @media(max-width: 1024px) {
        margin-left: 40%;
    }

    @media(max-width: 767px) {
        margin-left: 25%;
        width: 100%;
    }
`;



// WEBPACK FOOTER //
// ./src/views/Blog.js